import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
function CodeDesc() {
  const { user_data } = useSelector((state) => state.authentication);
  return (
    <div>
      <h3 className="lang-title">
        Use Any Language <br /> <span>Sample for All Major</span> <br />{" "}
        <span>Development Languages</span>
      </h3>
      <p className="lang-desc">
        Use Any Language Sample for <br /> All Major Development Languages
        <br />
        Create your application in any
        <br />
        language. No more C++/Java
        <br />
        limitations. Use the technology you
        <br />
        already know, and spend your time
        <br />
        creating your application, not integrating.
      </p>
      <Link
        type="button"
        to={user_data?.customer ? "/dashboard" : "/authentication/sign-up"}
        className="btn btn-vct py-3 px-3"
      >
        VCT Technologies on GitHub
      </Link>
    </div>
  );
}

export default CodeDesc;
